<template>
  <div class="preika-auth-page">
    <div class="preika-auth-shell">
      <section class="preika-auth-brand">
        <img
          src="/img/avatars/preika_black.png"
          alt="PREIKA"
          class="preika-auth-brand__logo"
        >

        <div class="preika-auth-brand__content">
          <p class="preika-auth-brand__eyebrow">CHECK YOUR INBOX</p>
          <h1>再設定用メールを<br>送信しました。</h1>
          <p>
            メールに記載されたURLからパスワードの再設定を行ってください。
            URLには有効期限があります。
          </p>
        </div>
      </section>

      <section class="preika-auth-form">
        <p class="preika-auth-form__eyebrow">EMAIL SENT</p>
        <h2>メールをご確認ください</h2>
        <p class="preika-auth-form__description">
          下記のメールアドレス宛に、パスワード再設定ページへのURLを送信しました。
        </p>

        <div class="alert alert-info">
          <strong>{{ email || '入力されたメールアドレス' }}</strong>
        </div>

        <p class="preika-auth-form__description">
          メールが届かない場合は、迷惑メールフォルダや入力したメールアドレスをご確認ください。
        </p>

        <div class="preika-auth-form__actions">
          <router-link
            :to="{ name: 'Login' }"
            class="preika-auth-form__forgot"
          >
            ログイン画面へ戻る
          </router-link>

          <router-link
            to="/sendemail"
            class="btn btn-secondary"
          >
            もう一度送信する
          </router-link>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmEmail',

  props: {
    email: {
      type: String,
      default: ''
    }
  }
}
</script>
